<template>
  <section class="py-5">
    <div class="container">
      <h3 class="fw-bold mb-3">Our Values</h3>
      <div class="row">
        <div class="col-md-3">
          <img src="../../assets/Images/home/creative1.png" alt="" />
        </div>
        <div class="col-md-9 d-flex justify-content-end">
          <img src="../../assets/Images/home/news.png" class="img-fluid" alt="">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import NewsSlider from './NewsSlider.vue'
export default {
  components: { NewsSlider },
  
}
</script>